<template>
  <AppFilterToolbar>
    <template #primary><AppInput :value="search" design="new" type="search" maxlength="255" placeholder="ID, recipient or message" aria-label="Search" @input="$emit('search', $event)" @keydown.enter.native="$emit('submit-search')" /></template>
    <AppDatePicker :value="period" design="new" range :input-attr="{ 'aria-label': 'Period · Asia/Dubai' }" placeholder="Period · Asia/Dubai" @input="setPeriod" />
    <AppSelect v-for="filter in filters" :key="filter.key" :value="selected(filter)" design="new" label="label" :aria-label="filter.label" :options="values(filter)" :reduce="option => option.value" :disabled="loading || single(filter)" :clearable="!single(filter)" :placeholder="filter.label" @input="change(filter.key, $event)" />
    <template v-if="$slots.selection" #selection><slot name="selection" /></template>
    <template #actions><slot name="actions" /></template>
    <template v-if="active" #clear><AppClearFiltersButton design="new" icon-only @clear="$emit('clear')" /></template>
  </AppFilterToolbar>
</template>

<script>
import Filters from './Filters.vue'

export default {
  name: 'OperationsFilters',
  extends: Filters,
  props: { active: Boolean }
}
</script>
